import * as React from 'react';
import styled from 'styled-components';
import { useRef } from 'react';
import { Container, ContainerPadding } from '@volkswagen-onehub/components-core';

const TimelineGtiSlideSection = styled.div<{ $bgColor: string }>`
  position: relative;
  background-color: ${({ $bgColor }) => $bgColor};
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  overflow: hidden;
`;

const BlockWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  aspect-ratio: 3 / 1;
  width: 100%;

  @media screen and (max-width: 959px) {
    aspect-ratio: auto;
    height: 100%;
  }
`;

const MkSvg = styled.img`
  position: absolute;
  top: 0;
  right: 5%;
  width: 50%;

  @media screen and (max-width: 959px) {
    top: 30vw;
    width: 80%;
  }
`;

const MkRender = styled.img`
  position: absolute;
  top: 15%;
  left: 0;
  width: 55%;

  @media screen and (max-width: 959px) {
    top: 50vw;
    width: 100%;
  }
`;

const PowerTextOverlay = styled.div`
  position: absolute;
  font-family: 'Futura Condensed Extra Bold', Futura, Arial, sans-serif;
  font-weight: bold;
  font-size: 100%;
  top: 60%;
  left: 56%;
  color: transparent;
  -webkit-text-stroke: 1px #ffffff;
  text-stroke: 1px #ffffff;

  @media screen and (max-width: 959px) {
    font-size: 12vw;
    left: auto;
    right: 5vw;
    top: 108vw;
  }
`;

const SliderText = styled.div`
  position: absolute;
  top: 85%;
  left: 57%;
  width: 40%;

  @media screen and (max-width: 959px) {
    left: auto;
    top: 120vw;
    margin: 5vw;
    width: auto;
  }
`;

const Title = styled.div`
  font-size: 3vh;
  font-family: 'Futura Condensed Extra Bold', Futura, Arial, sans-serif;
  text-transform: uppercase;
  width: 80%;
  white-space: pre-line;
`;

const Subtitle = styled.div`
  font-size: 2vh;
  font-family: Futura, Arial;
  font-weight: normal;
  margin-top: 10px;
`;

type TimelineGtiSlideProps = {
  label: string;
  year: number;
  power: number;
  title: string;
  subtitle: string;
  bgColor: string;
  color: string;
};

export const TimelineGtiSlideFrame: React.FC<TimelineGtiSlideProps> = ({
  label,
  power,
  title,
  subtitle,
  bgColor,
}): React.ReactElement => {
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <TimelineGtiSlideSection ref={sectionRef} $bgColor={bgColor}>
      <BlockWrapper>
        <MkRender
          src={`https://assets.volkswagen.com/is/image/volkswagenag/${label}-timeline?Zml0PWNyb3AlMkMxJndpZD0yMjIyJmhlaT0xMjUwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjQ2NDY=`}
        />
        <MkSvg
          src={`https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-gti50/timeline/${label}.png`}
        />
        <PowerTextOverlay>{power}CV</PowerTextOverlay>
        <SliderText>
          <Title>{title}</Title>
          <Container padding={{ right: ContainerPadding.static500 }}>
            <Subtitle>{subtitle}</Subtitle>
          </Container>
        </SliderText>
      </BlockWrapper>
    </TimelineGtiSlideSection>
  );
};
